// extracted by mini-css-extract-plugin
export default {"container":"RootRouter_container__+HhTN"};